import qs from 'qs';
import { get, post } from './request';

// 获取证书领取状态
export var getCertificateStatus = function getCertificateStatus(data, config) {
  return get('/question_active/certificate_info', data, config);
};

// 领取证书
export var getCertificate = function getCertificate(data, config) {
  return post('/question_active/certificate_receive', qs.stringify(data), config);
};

// 查看证书详情
export var getCertificateDetail = function getCertificateDetail(data, config) {
  return get('/question_active/certificate_my', data, config);
};

// 是否弹领取证书
export var isPopCertificate = function isPopCertificate(data, config) {
  return get('/question_active/certificate_status', data, config);
};